import React from "react";
import { useNavigate } from "react-router-dom";

const ProjectCard = ({ project }) => {
	const navigate = useNavigate();

	const handleImageClick = (e) => {
		e.stopPropagation();
		if (project.websiteUrl) {
			window.open(project.websiteUrl, "_blank");
		}
	};

	const handleCardClick = () => {
		// All projects go to their website URLs
		if (project.websiteUrl) {
			window.open(project.websiteUrl, "_blank");
		}
	};

	const handleGitHubClick = (e) => {
		e.stopPropagation();
		if (project.githubUrl) {
			window.open(project.githubUrl, "_blank");
		}
	};

	const handleFigmaClick = (e) => {
		e.stopPropagation();
		if (project.figmaUrl) {
			window.open(project.figmaUrl, "_blank");
		}
	};

	return (
		<div key={project.id} className="project" id={project.id} onClick={handleCardClick}>
			<div className="project-content">
				<div className="project-header">
					{project.figmaUrl && (
						<div className="figma-link">
							<button className="figma-button" onClick={handleFigmaClick} title="View Figma Prototype">
								<img src={`${process.env.PUBLIC_URL}/images/figma.png`} alt="Figma" className="figma-logo" />
							</button>
						</div>
					)}
					<p className="project-title">{project.title}</p>
					{project.githubUrl && (
						<div className="github-link">
							<button className="github-button" onClick={handleGitHubClick} title="View on GitHub">
								<img src={`${process.env.PUBLIC_URL}/images/github-white-icon.webp`} alt="GitHub" className="github-logo" />
							</button>
						</div>
					)}
				</div>
				{project.images ? (
					<div className="project-images">
						{project.images.map((img, index) => (
							<img
								key={index}
								src={img}
								className="project-image"
								alt={`${project.title} ${index + 1}`}
								onClick={handleImageClick}
							/>
						))}
					</div>
				) : (
					<img src={project.image} className="project-image" alt={project.title} onClick={handleImageClick} />
				)}
				<p className="project-description">
					{project.description.split("\n").map((line, index) => (
						<React.Fragment key={index}>
							{line}
							{index < project.description.split("\n").length - 1 && <br />}
							{index < project.description.split("\n").length - 1 && <br />}
						</React.Fragment>
					))}
				</p>
				<div className="project-bottom">
					<div className="tools">
						{project.tools.map((tool, index) => (
							<div key={index} className="tool">
								{tool}
							</div>
						))}
					</div>
					<div className="achievements">
						{project.achievements.map((achievement, index) => (
							<div key={index} className="achievement">
								<img src={`${process.env.PUBLIC_URL}/images/check.svg`} alt="Check" />
								<p>{achievement}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProjectCard;
